import React from "react";
import FadeIn from "../components/FadeIn";

export default function NewAlbert({ lang, t }) {
  const einsteinImage = "https://assets.auxodev.dk/assets/25c88f45-a091-4778-ada1-e41c6b1f66ac/newalbert-green_1.png";

  return (
    <section id="newalbert" className="relative w-full min-h-screen bg-zinc-100 font-sans py-16 md:py-24 px-6 md:px-12 flex flex-col justify-center border-b border-zinc-200">
      <FadeIn className="max-w-6xl mx-auto w-full space-y-6 md:space-y-8 my-auto">
        {/* Two-Column Grid */}
        <div className="bg-white border border-zinc-200 pt-12 pb-6 px-6 md:p-8 rounded-none shadow-sm grid grid-cols-1 lg:grid-cols-12 gap-8 items-center relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-brand-green"></div>
          
          {/* Left Column: Content */}
          <div className="lg:col-span-8 space-y-6">
            {/* Main Header */}
            <div className="space-y-2">
              <span className="text-xs font-bold text-brand-green uppercase tracking-[0.25em] block">
                {t("newalbert.welcome")}
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-brand-navy leading-tight font-display">
                {t("newalbert.title")}{" "}
                <span className="text-brand-blue block mt-0.5">
                  {t("newalbert.subtitle")}
                </span>
              </h2>
            </div>

            {/* Sub-section with Feature List */}
            <div className="space-y-6">
              <h3 className="text-[10px] font-bold text-zinc-400 uppercase tracking-[0.2em] border-b border-zinc-100 pb-2">
                {t("newalbert.coreTechTitle")}
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Feature Item 1 */}
                <div className="bg-zinc-50 p-4 border border-zinc-200 relative group hover:border-brand-blue transition-colors duration-200">
                  <div className="absolute top-0 left-0 w-1 h-full bg-brand-blue"></div>
                  <div className="h-6 w-6 bg-brand-blue/10 text-brand-blue flex items-center justify-center font-bold text-xs mb-3">
                    <i className="fa-solid fa-network-wired" aria-hidden="true" />
                  </div>
                  <p className="font-bold text-brand-navy text-sm mb-1 font-display">
                    {t("newalbert.ragTitle")}
                  </p>
                  <p className="text-zinc-500 font-light text-xs leading-relaxed">
                    {t("newalbert.ragText")}
                  </p>
                </div>

                {/* Feature Item 2 */}
                <div className="bg-zinc-50 p-4 border border-zinc-200 relative group hover:border-brand-green transition-colors duration-200">
                  <div className="absolute top-0 left-0 w-1 h-full bg-brand-green"></div>
                  <div className="h-6 w-6 bg-brand-green/10 text-brand-green flex items-center justify-center font-bold text-xs mb-3">
                    <i className="fa-solid fa-brain" aria-hidden="true" />
                  </div>
                  <p className="font-bold text-brand-navy text-sm mb-1 font-display">
                    {t("newalbert.reasoningTitle")}
                  </p>
                  <p className="text-zinc-500 font-light text-xs leading-relaxed">
                    {t("newalbert.reasoningText")}
                  </p>
                </div>
              </div>

              {/* Bottom Narrative */}
              <div className="bg-brand-green/5 border border-brand-green/20 p-4 relative">
                <div className="absolute top-0 left-0 w-1 h-full bg-brand-green"></div>
                <p className="text-xs md:text-sm leading-relaxed text-brand-navy font-medium">
                  {t("newalbert.beyondSearch")}
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: Avatar/Image Panel */}
          <div className="lg:col-span-4 flex justify-center lg:justify-end">
            <div className="w-full max-w-[220px] aspect-square flex items-center justify-center relative">
              <img
                src={`https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=90,format=auto/${einsteinImage.replace("https://assets.auxodev.dk/", "")}`}
                alt="NewAlbert AI Forskningspartner"
                width="220"
                height="220"
                loading="lazy"
                className="w-full h-full object-cover relative z-10 hover:scale-105 transition-all duration-500"
              />
            </div>
          </div>
        </div>
      </FadeIn>
    </section>
  );
}
